/**
 * Stats tab groups — selected campaigns sharing one traffic link become one tab.
 * The group keeps its campaign's tracker as-is (Tres Commas is never read as
 * Voluum); rows without a provider stay Voluum as they always were.
 * For Media Devoted | Created By Ciro Autiero
 */

import { statsTrafficProvider } from '@/features/trackers/stats-tracker';
import { trafficCampaignGroupKey } from '@/pages/admin/SmswiserCampaignDetailPage/sections/stats-traffic/traffic-group-key';
import type { TabGroup } from '@/pages/admin/SmswiserCampaignDetailPage/types';

export type StatsCampaign = TabGroup['campaigns'][number];

function toTabGroup(sameGroup: StatsCampaign[]): TabGroup {
  const fullLabel =
    sameGroup.length > 1 ? sameGroup.map((x) => x.name).join(', ') : sameGroup[0]!.name;
  const label =
    sameGroup.length > 2 ? `${sameGroup[0]!.name} (+${sameGroup.length - 1} more)` : fullLabel;
  const first = sameGroup[0]!;
  const trafficProvider = statsTrafficProvider(first.trafficProvider);
  const rawId = first.trafficCampaignId ?? first.voluumCampaignId;
  const trafficCampaignId =
    rawId != null && String(rawId).trim() !== '' ? String(rawId).trim() : null;
  return {
    wiserIds: sameGroup.map((x) => x.id),
    trafficProvider,
    trafficCampaignId,
    campaigns: sameGroup,
    label,
    fullLabel,
  };
}

export function buildTabGroups(campaignsForStats: StatsCampaign[]): TabGroup[] {
  const groups: TabGroup[] = [];
  const seen = new Set<number>();
  for (const c of campaignsForStats) {
    if (seen.has(c.id)) continue;
    const gk = trafficCampaignGroupKey(c);
    const sameGroup = campaignsForStats.filter((x) => trafficCampaignGroupKey(x) === gk);
    for (const x of sameGroup) seen.add(x.id);
    groups.push(toTabGroup(sameGroup));
  }
  return groups;
}
